// @ts-nocheck -- copied verbatim from the application being replaced.
//
// Quarantined, not exempted. This file has not been rewritten to this project's
// settings and does not pass them; checking it would report errors nobody is
// going to fix in place, and loosening the settings to accommodate it would
// apply that to code written here too. Vite still compiles it -- esbuild strips
// types without checking them.
//
// Delete this line when the file is rewritten. It is the marker for what is left
// to do, and the count of files carrying it is the size of the refactor.
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
